$(document).ready(function() {

    /*******************************************/
    //Form Validation
    $('.validate-form').each(function() {
        $(this).validate({
            submitHandler: function(form) {
                form.submit();
            },
            rules: {
                required: true
            },
            errorPlacement: function(error, element) {
                error.appendTo(element.parents('.form-field'));
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
                }
            }
        });
    });

    /*******************************************/
    // Research Journal  Toggle
    $('.js-toggle-journal').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('active')
    });

    /*******************************************/
    // Publication File toggle
    $('.js-toggle-journal-summary').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
    });

    /*******************************************/
    //Lightbox Initiations
    $('.js-inline-popup').magnificPopup({
        type:'inline',
        showCloseBtn: true,
        closeOnBgClick: true
    });

    $('.js-image-popup').magnificPopup({
        type: 'image',
        showCloseBtn: true,
        closeOnBgClick: true
    });

    $('.lightbox-manual-close-trigger').click(function(event) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    /*******************************************/
    // Tabs
    $('.js-tab-triggers a').on('click', function(e) {
        e.preventDefault();
        $('.js-tab-triggers a').not(this).removeClass('active');
        $(this).addClass('active');
        var getTarget = $(this).attr('href');
        $('.tab-content').not(getTarget).hide();
        $(getTarget).show();
    });

    /*******************************************/

});
/*******************************************/


$.fn.toggleHTML = function(t1, t2) {
    if (this.html() == t1) this.html(t2);
    else this.html(t1);
    return this;
};

/*******************************************/






// WEBPACK FOOTER //
// ./resources/assets/frontend/js/scripts/common.js